import React, { useEffect, useState, useContext } from "react";
import { connect } from "react-redux";
import "./index.css";
import ContextForm from "../../ReportForm/contextForm";

const CustomRadioButton = (props) => {
  const { label, options, isRequired, onChange, vertical } = props;
  const context = useContext(ContextForm);
  const { errorFieldsPublicForm, errorFieldsProfessionalForm } = context;

  const [isSelected, setIsSelected] = useState(null);

  const [errorField, setErrorField] = useState(false);
  const handleChange = (index, item) => {
    if (errorField) {
      setErrorField(false);
    }
    setIsSelected(index);
    onChange(item);
  };

  useEffect(() => {
    if (
      isSelected === null &&
      isRequired &&
      (errorFieldsPublicForm === true || errorFieldsProfessionalForm === true)
    ) {
      setErrorField(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorFieldsPublicForm, errorFieldsProfessionalForm]);

  useEffect(() => {
    return () => { };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="element">
      <label className="label">
        {label}
        {isRequired && <span>*</span>}
      </label>
      <div
        // className="container-pair-radio-button"
        className={`container-pair-radio-button ${errorField ? "error_form" : ""
          }`}
        style={{ flexDirection: vertical ? "column" : "row" }}
      >
        {options &&
          Array.isArray(options) === true &&
          options.map((item, index) => {
            return (
              <div className="pair-radio-button">
                <div
                  className={`${isSelected === index ? "selected-radio" : "radio"}`}
                  onClick={() => {
                    handleChange(index, item);
                  }}
                >
                  <div className={`${isSelected === index ? "selected-radio-content" : ""}`} />
                </div>
                <label className="label-radio" for={item}>
                  {item}
                </label>
              </div>
            );
          })}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  settings: state.settings,
});

export default connect(mapStateToProps)(CustomRadioButton);
